<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InboxButton" });
import Button from "../button/Button.svelte";
import { CONFIG } from "./config.js";
export let email = void 0;
let config = void 0;
let domain = void 0;
$: domain = email === void 0 ? void 0 : email.split("@").pop();
$: config = domain === void 0 ? void 0 : CONFIG.find((config2) => config2.domains.includes(domain));
</script>

{#if config !== undefined }
    <Button url = { config.url } label = { `${ config.label } Inbox` } color = 'dark'/>
{/if}